
import { Component } from 'vue-property-decorator';

// SVG
import ProjectsSVG from '@/assets/icon-projects.svg';
import ChartsSVG from '@/assets/icon-charts.svg';
import ReportsSVG from '@/assets/icon-reports.svg';

// Components
import { VAppHeader, VAppLayout, VAppMain, VAppSidebar, VAppSidebarNavigation } from '@/components/VApp';
import VErrorViewer from '@/components/VErrorViewer.vue';

// Interfaces
import AppSidebarNavigationLink from '@/ship/Models/AppSidebarNavigationLink';

// Utils
import { get } from 'lodash';
import { hasAllPermissions, hasCurrentRoutePermission } from '@/utils/Permissions';

// Mixin
import PMMixin from '@/mixins/PMMixin';

@Component({
    components: {
        VAppHeader,
        VAppLayout,
        VAppMain,
        VAppSidebar,
        VAppSidebarNavigation,
        VErrorViewer,
    },
})
export default class ProjectManagementPage extends PMMixin {
    isLoading = false;

    linksList: AppSidebarNavigationLink[] = [];

    get showSidebar() {
        return get(this.$route.meta, 'showSidebar');
    }

    get hasRoutePermission(): boolean {
        return hasCurrentRoutePermission();
    }

    get filteredLinksList(): AppSidebarNavigationLink[] {
        const filteredFirstDepth = this.filterLinksList(this.linksList);
        return filteredFirstDepth.map((link) => ({
            ...link,
            children: link.children && this.filterLinksList(link.children),
        }));
    }

    filterLinksList(linksList: AppSidebarNavigationLink[]) {
        return linksList.filter((link) => {
            return link.children || (link.permissions ? hasAllPermissions(link.permissions) : true);
        });
    }

    getLinkList() {
        return [
            {
                label: this.$t(`${this.prefix}.projects.menu`),
                to: { name: 'projectManagement.projects' },
                icon: ProjectsSVG,
            },
            {
                label: this.$t(`${this.prefix}.charts.menu`),
                to: { name: 'projectManagement.charts' },
                icon: ChartsSVG,
            },
            {
                label: this.$t(`${this.prefix}.reports.menu`),
                to: { name: 'projectManagement.reports' },
                icon: ReportsSVG,
            },
        ];
    }

    async created() {
        this.linksList = this.getLinkList();
        // redirect to the first available page if the route is projectManagement
        if (this.$route.name === 'projectManagement' && this.filteredLinksList.length) {
            this.$router.replace(this.filteredLinksList[0].to);
        }
    }
}
